const ActionTypes = {
  REFERSH_NOTIFICATION_COUNT: "REFERSH_NOTIFICATION_COUNT",
};

export default ActionTypes;



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/actions/NotificationCountActionTypes.js